import { Image } from "expo-image";
import { StyleSheet, View } from "react-native";

import { spacing } from "@/src/theme/tokens";

type Props = { compact?: boolean };

export function BrandIntro({ compact = false }: Props) {
  return (
    <View accessible accessibilityLabel="Neqraw, نقراو. On étudie. Ensemble." style={styles.container}>
      <Image
        accessibilityIgnoresInvertColors
        contentFit="contain"
        source={require("@/assets/brand/logos/logo-main-dark.png")}
        style={[styles.logo, compact && styles.compactLogo]}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { alignSelf: "flex-start", marginHorizontal: -spacing.sm },
  logo: { aspectRatio: 2.5, width: 300 },
  compactLogo: { width: 240 },
});
